import { render } from "./ChangeManagement.vue?vue&type=template&id=8501f98c"
import script from "./ChangeManagement.vue?vue&type=script&lang=js"
export * from "./ChangeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__